export default __webpack_public_path__ + "static/media/ag-kids.ea7aca76.svg";